import React from 'react';



type Props = {
  className?: string;
};
export const OpenCameraVector: React.FC<Props> = ({ className }) => {
  return (
    <svg className = {className} width = '32' height = '32' viewBox = '0 0 32 32' fill = 'none' xmlns = 'http://www.w3.org/2000/svg'>
      <path fill = '#0041A0' d = 'M25.087 10.7619H22.0548L20.3043 8.85714H14.5652V10.7619H19.4626L21.213 12.6667H25.087V24.0952H9.78261V15.5238H7.86957V24.0952C7.86957 25.1429 8.73043 26 9.78261 26H25.087C26.1391 26 27 25.1429 27 24.0952V12.6667C27 11.619 26.1391 10.7619 25.087 10.7619ZM12.6522 18.381C12.6522 21.0095 14.7948 23.1429 17.4348 23.1429C20.0748 23.1429 22.2174 21.0095 22.2174 18.381C22.2174 15.7524 20.0748 13.619 17.4348 13.619C14.7948 13.619 12.6522 15.7524 12.6522 18.381ZM17.4348 15.5238C19.013 15.5238 20.3043 16.8095 20.3043 18.381C20.3043 19.9524 19.013 21.2381 17.4348 21.2381C15.8565 21.2381 14.5652 19.9524 14.5652 18.381C14.5652 16.8095 15.8565 15.5238 17.4348 15.5238ZM9.78261 10.7619H12.6522V8.85714H9.78261V6H7.86957V8.85714H5V10.7619H7.86957V13.619H9.78261V10.7619Z' />
    </svg>
  );
};